import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { FormControl }    from '@angular/forms';
import { Item } from '../item';
import * as moment from 'moment';
import { AngularFireAuth } from '@angular/fire/auth';
import { SharedValueService } from '../sharedValue.service';
import { SendemailService } from '../sendemail.service';

@Component({
  selector: 'app-dblist',
  templateUrl: './dblist.component.html',
  styleUrls: ['./dblist.component.css']
})

export class DblistComponent implements OnInit {

  @Input() afAuthChild: AngularFireAuth;
  //@Input() isLoggedIn: Boolean;                //ログインしているか。

    // 取得したドキュメントを格納
    private itemsCollection: AngularFirestoreCollection<Item>;
    items: Observable<Item[]>;
    
    /** フォームコントロール（追加用） */
    formDocId = new FormControl('');
    formUid = new FormControl('');
    formContributor = new FormControl('');
    formMessage = new FormControl('');
    formEmail = new FormControl('');
    formTimestamp = new FormControl('');
    /** フォームコントロール（更新用） */
    formUpdatedDocId = new FormControl('');
    formUpdatedUid = new FormControl('');
    formUpdatedContributor = new FormControl('');
    formUpdatedMessage = new FormControl('');
    formUpdatedEmail = new FormControl('');
    formUpdatedTimestamp = new FormControl('');
    /** フォームコントロール（返信用） */
    formReplyPerson = new FormControl('');
    formReplyMessage = new FormControl('');
    /** モードを実行するためのフラグ */
    isEnabledRevise = false;           //編集ボタンを表示するか。
    isEnabledDelete = false;           //削除ボタンを表示するか。
    isEnabledReplyEdit = false;        //返信ボタンを表示するか。
    /** ↓表示中のドキュメントページ */
    previousEntry: any = "";
    latestEntry: any = "";
    viewLength = 20;  // 表示件数
    viewTotal = 0;    // 総レコード数

    // DI（依存性注入する機能を指定）データベース・コレクション名がfunnysnowman。
    constructor(private db: AngularFirestore, private sharedValue: SharedValueService, private sendEmail: SendemailService) {
      // 全レコードを取得
      this.itemsCollection = db.collection<Item>('funnysnowman', ref => {
        return ref.orderBy('timestamp', 'desc')
      })
      // 総レコード数を取得する
      this.itemsCollection.snapshotChanges().subscribe(response => {
        console.log("KANO total:"+response.length);
        this.viewTotal = response.length;
      });    
      this.showNext();
    }

    ngOnInit() {
      /** Read: パスにあるドキュメントが変更されるとイベントが発生してデータを参照（ストリームに変換） */
      this.items = this.itemsCollection.valueChanges();   // データベースから読み込みしている。
    }

  /** HTMLで表示する文字列を返す */
  get strLoginUserName() { 
    if(this.sharedValue.strLoginUser == "") {
      this.sharedValue.strLoginUser = "匿名";
      return `匿名`; 
    } else {
      return `${this.sharedValue.strLoginUser}`; 
    }
  }
  get strIsLoggedIn() { return `${this.sharedValue.isLoggedIn}`; }
  get strUid() { return `${this.sharedValue.strUid}`; }
  /** もしも管理者なら、管理モードになる。 */
  get strKANO() { 
    if(this.sharedValue.strEmail == 'ichiro.kano2@gmail.com') {
      return true;
    } else {
      return false;
    }
  }

  // 次の［コメントｘＮ個］を表示する。
  showNext() {
    this.previousEntry = this.latestEntry;

    // 最初は先頭から、二回目は[latestEntry]の日時から、[viewLength]の数だけコメントを表示する
    if (!this.latestEntry) {
      this.itemsCollection = this.db.collection<Item>('funnysnowman', ref => {
        return ref.orderBy('timestamp', 'desc')
          .limit(this.viewLength)
        });
    } else {
        this.itemsCollection = this.db.collection<Item>('funnysnowman', ref => {
          return ref.orderBy('timestamp', 'desc')
            .startAfter(this.latestEntry)         //.startAfter('2006/12/8 2:10')
            .limit(this.viewLength)
        });
    }

    // 最後に表示したレコードの日時を[latestEntry]に代入しておく。
    this.itemsCollection.snapshotChanges().subscribe(response => {
      if (!response.length) {
        console.log("KANO: No more data available.");
        return false;
      } else {
        for (let item of response) { this.latestEntry = item.payload.doc.get('timestamp'); }
        console.log("KANO previousData:"+ this.previousEntry);
        console.log("KANO lastData:"+ this.latestEntry);
        return this.latestEntry;
      }
    } );
    //HTML表示を更新する
    return this.items = this.itemsCollection.valueChanges(); 
  }

  // 前の［コメントｘＮ個］を表示する。
  showPrevious() {
    // 最初は先頭から、二回目は[latestEntry]の日時から、[viewLength]の数だけコメントを表示する
    if (!this.previousEntry) {
      this.itemsCollection = this.db.collection<Item>('funnysnowman', ref => {
        return ref.orderBy('timestamp', 'desc')
          .limit(this.viewLength)
        });
    } else {
        this.itemsCollection = this.db.collection<Item>('funnysnowman', ref => {
          return ref.orderBy('timestamp', 'desc')
            .startAfter(this.previousEntry)         //.startAfter('2006/12/8 2:10')
            .limit(this.viewLength)
        });
    }
    // 最後に表示したレコードの日時を[latestEntry]に代入しておく。
    this.itemsCollection.snapshotChanges().subscribe(response => {
      if (!response.length) {
        console.log("KANO: No more data available.");
        return false;
      } else {
        for (let item of response) { this.latestEntry = item.payload.doc.get('timestamp'); }
        console.log("KANO previousData:"+ this.previousEntry);
        console.log("KANO lastData:"+ this.latestEntry);
        return this.latestEntry;
      }
    } );
    // HTML表示を更新する
    return this.items = this.itemsCollection.valueChanges();
  }


  /** Create: データを追加 */
  addItem(): void {
    this.formUid.setValue("-");
    // もしログイン済みユーザなら、投稿者やUIDを自動入力する
    if(this.sharedValue.isLoggedIn==true) {
        this.formContributor.setValue( this.sharedValue.strLoginUser );
        this.formEmail.setValue( this.afAuthChild.auth.currentUser.email );
        this.formUid.setValue( this.sharedValue.strUid );
      }
    
    // DBに書き込みする
    const docid = this.db.createId();                      // 新しい投稿なのでドキュメントIDを作成する
    const item: Item = {
        docid,
        uid: this.formUid.value,                           // ログインした人のUser-ID
        contributor: this.formContributor.value,
        message: this.formMessage.value,
        email: this.formEmail.value,
        timestamp: moment().format("YYYY-MM-DD HH:mm:ss"), //作成日時を自動作成する
        //timestamp: this.formTimestamp.value,
        replyPerson: "",
        replyMessage: "",
    };
    this.itemsCollection.doc(docid).set(item);  // データベースに書き込み実行
    this.clearFormValue();

    // メール送信　aws lambda
    this.sendEmail.sendEmail();
  }

    /** Update: データを更新 */
  updateItem(): void {
    const item = {
      docid: this.formUpdatedDocId.value,
      contributor: this.formUpdatedContributor.value,
      message: this.formUpdatedMessage.value,
      email: this.formUpdatedEmail.value,
    };
    this.itemsCollection.doc(item.docid).update(item);

    this.isEnabledRevise = false;
    this.isEnabledDelete = false;
  }

  /** 編集用のフォームにデータを表示 */
  editItem(item: Item): void {
      this.formUpdatedDocId.setValue(item.docid);
      this.formUpdatedContributor.setValue(item.contributor);
      this.formUpdatedMessage.setValue(item.message);
      this.formUpdatedEmail.setValue(item.email);

      this.isEnabledRevise = true;
      this.isEnabledDelete = true;
  }

      /** 返信用のフォームにデータを表示  */
  replyEditItem(item: Item): void {
    this.formDocId.setValue(item.docid);
    this.formReplyPerson.setValue(item.replyPerson);
    this.formReplyMessage.setValue(item.replyMessage);
    this.isEnabledReplyEdit = true;
  }


/** reply: 返信データを追加 */
  replyItem(): void {
    const item = {
        docid: this.formDocId.value,
        replyPerson: this.formReplyPerson.value,
        replyMessage: this.formReplyMessage.value,
    };
    this.itemsCollection.doc(item.docid).update(item);  // データベースに書き込み実行
    this.isEnabledReplyEdit = false;
  }

  /** データを削除 */
  deleteItem(item: Item): void {
    this.itemsCollection.doc(item.docid).delete();
  }

  // 入力フォームの値をクリアする
  clearFormValue(): void {
    this.formUid.setValue('');
    this.formContributor.setValue('');
    this.formMessage.setValue('');
    this.formEmail.setValue('');
    this.formTimestamp.setValue('');
    this.formReplyPerson.setValue('');
    this.formReplyMessage.setValue('');

    this.formUpdatedDocId.setValue('');
    this.formUpdatedContributor.setValue('');
    this.formUpdatedMessage.setValue('');
    this.formUpdatedEmail.setValue('');
  }



}